import { CommonModule } from "@angular/common";
import { Component, HostListener, Input } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { CartState } from "../../../../store/state/cart.state";
import { Observable } from "rxjs";
import { Cart, CartAddOrUpdate } from "../../../../interface/cart.interface";
import { ThemeOptionState } from "../../../../store/state/theme-option.state";
import { SettingState } from "../../../../store/state/setting.state";
import { Values } from "../../../../interface/setting.interface";
import { Option } from "../../../../interface/theme-option.interface";
import { CartService } from "../../../../services/cart.service";
import {
  GetCartItems,
  ToggleSidebarCart,
} from "../../../../store/action/cart.action";
import { CurrencySymbolPipe } from "../../../../pipe/currency.pipe";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonComponent } from "../../../widgets/button/button.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { VariationModalComponent } from "../../../widgets/modal/variation-modal/variation-modal.component";
import { RouterModule } from "@angular/router";
import { CommonState } from "../../../../store/state/common.state";
import {
  APIHeaderVM,
  APIResponseVM,
} from "../../../../../core/models/common/common.model";
import { TZDProductMasterService } from "../../../../../core/services/api/tzd-product-master.service";
import { SingletonStoreService } from "../../../../../core/services/helper/singleton-store.service";
import { GetTZDUserCartResVM, SaveTZDUserCartReqVM } from "../../../../../core/models/api/tzd-product-master.model";
import { ActionTypeEnum, ResponseCodeEnum } from "../../../../../core/enums/common.enum";
import { ConfirmationModalComponent } from "../../../widgets/modal/confirmation-modal/confirmation-modal.component";
import { NotificationService } from "../../../../services/notification.service";

@Component({
  selector: "app-cart",
  standalone: true,
  imports: [
    CommonModule,
    CurrencySymbolPipe,
    TranslateModule,
    RouterModule,
    ButtonComponent,
    VariationModalComponent,
  ],
  templateUrl: "./cart.component.html",
  styleUrl: "./cart.component.scss",
})
export class CartComponent {
  @Select(CartState.sidebarCartOpen) sidebarCartOpen$: Observable<boolean>;
  @Select(ThemeOptionState.themeOptions) themeOption$: Observable<Option>;
  @Select(SettingState.setting) setting$: Observable<Values>;
  @Select(CommonState.commonHeaderDetails) commonHeaderDetails$: Observable<
    APIResponseVM<APIHeaderVM>
  >;
  @Select(CartState.cartItems) cartItems$: Observable<GetTZDUserCartResVM[]>;
  @Select(CartState.cartTotal) cartTotal$: Observable<number>;

  @Input() style: string = "basic";

  public cartStyle: string = "cart_sidebar";
  public cart: string;
  // public shippingFreeAmt: number = 0;
  // public cartTotal: number = 0;
  // public shippingCal: number = 0;
  // public confettiItems = Array.from({ length: 150 }, (_, index) => index);
  // public confetti: number = 0;
  // public loader: boolean = false;
  // public width: number;
  cartItemDetailList: GetTZDUserCartResVM[] = [];
  totalPrice: number = 0;
  isLoading: boolean = false;

  constructor(
    private store: Store,
    public cartService: CartService,
    private modal: NgbModal,
    private tzdProductMasterService: TZDProductMasterService,
    private singletonStoreService: SingletonStoreService,
    private notificationService: NotificationService
  ) {
    this.themeOption$.subscribe((option) => {
      this.cartStyle = option?.general?.cart_style;
      this.cart = this.cartStyle;
    });

    this.commonHeaderDetails$.subscribe({
      next: (resData: APIResponseVM<APIHeaderVM>) => {
        if (resData?.data?.CompanyId) {
          this.getCartData();
        }
      },
    });
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: { target: { innerWidth: number } }) {
    if (this.cartStyle == "cart_mini") {
      if (event.target.innerWidth <= 767) {
        this.cart = "cart_sidebar";
      } else if (event.target.innerWidth > 767) {
        this.cart = "cart_mini";
      }
    }
  }

  getCartData() {
    this.cartItems$.subscribe({
      next: (resData: GetTZDUserCartResVM[]) => {
        if (resData?.length > 0) {
          this.cartItemDetailList = resData;          
        }else{
          this.cartItemDetailList = [];
        }
      },
    });
    this.cartTotal$.subscribe({
      next: (resData: number) => {
        if (resData > 0) {
          this.totalPrice = resData;          
        }else{
          this.totalPrice = 0;
        }
      },
    });
  }

  cartToggle(value: boolean) {
    this.store.dispatch(new ToggleSidebarCart(value));
  }

  updateQuantity(
    item: GetTZDUserCartResVM,
    qty: number,
    isDelete: boolean = false
  ) {
    if (item && !this.isLoading) {
      this.isLoading = true;
      this.singletonStoreService.action.next(ActionTypeEnum.Add);
      const payload: SaveTZDUserCartReqVM = {
        userCartId: item?.UserCartId,
        productId: item?.ProductId,
        quantity: item?.Quantity + qty,
        uomId: item?.UOMId,
        isDeleted: isDelete,
      };
      this.tzdProductMasterService.save_tzd_user_cart(payload).subscribe({
        next: (res: APIResponseVM<any>) => {
          if (res.responseCode === ResponseCodeEnum.SUCCESS) {
            this.store.dispatch(new GetCartItems());
            if (isDelete) {
              this.notificationService.showSuccess(res?.message);
            }
          }
          this.isLoading = false;
        },
        error: (err) => {
          this.isLoading = false;
        },
      });
    }
  }

  deleteProductToCart(data: GetTZDUserCartResVM) {
    const modal = this.modal.open(ConfirmationModalComponent, {
      centered: true,
      windowClass: "",
    });
    modal.componentInstance.confirm.subscribe((val: boolean) => {
      if (val === true) {
        this.updateQuantity(data, 0, true);
      }
    });
  }

  clearCart() {
    // this.store.dispatch(new ClearCart());
  }
}
